const POSITIONS: Array<{ top: string; left: string }> = [
  { top: '0%', left: '0%' },
  { top: '0%', left: '50%' },
  { top: '0%', left: '100%' },
  { top: '33.33%', left: '100%' },
  { top: '66.66%', left: '100%' },
  { top: '100%', left: '100%' },
  { top: '100%', left: '50%' },
  { top: '100%', left: '0%' },
  { top: '66.66%', left: '0%' },
  { top: '33.33%', left: '0%' },
];

const DURATION_MS = 800;

export function DotGridLoader() {
  return (
    <div
      className="relative h-3 w-2"
      role="status"
      aria-label="Loading"
    >
      {POSITIONS.map((pos, i) => (
        <div
          key={i}
          className="absolute h-0.5 w-0.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-surface-500 animate-[dot-pulse_0.8s_ease-in-out_infinite]"
          style={{
            top: pos.top,
            left: pos.left,
            animationDelay: `${(DURATION_MS / POSITIONS.length) * i}ms`,
          }}
        />
      ))}
    </div>
  );
}
